<template>
  <li role="menuitem" class="header-nav__item">
    <router-link :exact="exact" :to="{ name: route }">
      <slot />
      <span class="label">
        <slot name="label" />
      </span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'header-nav-item',
  props: {
    route: {
      required: true,
      type: String,
    },
    exact: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.header-nav__item {
  font-weight: 500;
  display: flex;
  margin-right: 1rem;

  a {
    color: inherit;
    opacity: 0.8;
    transition: all 128ms ease-in-out;
  }

  .router-link-active {
    opacity: 1;
    span {
      color: color('primary');
    }
  }

  .label {
    display: none;
  }
}

@media screen and (min-width: 1024px) {
  .header-navigation {
    .label {
      display: flex;
    }
  }
}

@media screen and (min-width: 1024px) {
  .header-nav__item {
    margin-right: 2rem;
  }
}
</style>
